/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUserContactResponse } from './CreateUserContactResponse';
import {
    CreateUserContactResponseFromJSON,
    CreateUserContactResponseFromJSONTyped,
    CreateUserContactResponseToJSON,
    CreateUserContactResponseToJSONTyped,
} from './CreateUserContactResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateUserContactResponse
 */
export interface ResultOfCreateUserContactResponse {
    /**
     * 
     * @type {CreateUserContactResponse}
     * @memberof ResultOfCreateUserContactResponse
     */
    data: CreateUserContactResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateUserContactResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateUserContactResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateUserContactResponse interface.
 */
export function instanceOfResultOfCreateUserContactResponse(value: object): value is ResultOfCreateUserContactResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateUserContactResponseFromJSON(json: any): ResultOfCreateUserContactResponse {
    return ResultOfCreateUserContactResponseFromJSONTyped(json, false);
}

export function ResultOfCreateUserContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateUserContactResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateUserContactResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateUserContactResponseToJSON(json: any): ResultOfCreateUserContactResponse {
    return ResultOfCreateUserContactResponseToJSONTyped(json, false);
}

export function ResultOfCreateUserContactResponseToJSONTyped(value?: ResultOfCreateUserContactResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateUserContactResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

